export default __webpack_public_path__ + "static/media/logo.mail.07921f77.png";